






















// vue
import { defineComponent, ref } from '@vue/composition-api';

// sotre
import { useStore } from '@/store';

// primevue
import InputSwitch from 'primevue/inputswitch';

export default defineComponent({
    name: 'VisibilityTab',
    components: {
        InputSwitch,
    },
    props: {
        geoRecord: {
            type: Object,
            required: true,
        },
        handleGeoRecordPropertyUpdate: {
            type: Function,
            default: () => {},
        },
    },
    setup(props: any) {
        // store
        const store = useStore();

        // methods
        const setIsPrivate = (): void => {
            props.handleGeoRecordPropertyUpdate({isPrivate: !props.geoRecord.isPrivate})
        };

        return {
            store,
            setIsPrivate,
        };
    },
});
